import React from "react";
import { FieldLabel, FieldValue, TextField } from "@td/ui";
import { translate, I18n } from "@td/shared_utils";
import { fieldTypes, specialtyCodes } from "../../constants";
import { useProviderPanels } from "../../contexts/provider-panels-context";
import { useProviderPanel } from "../../contexts/provider-panel-context";
import styles from "./styles.module.scss";

const MaxPanelField = React.memo(() => {
  const { specialtyCode } = useProviderPanels();
  const { practiceTeamParticipant: participant } = useProviderPanel();

  return (
    <FieldLabel>
      <div>
        {translate(null, "provider_panel.form.fields.max_panel", "label")}
      </div>

      <FieldValue>
        <div>
          <I18n
            scope="provider_panel.form.fields.max_panel"
            text={specialtyCode === specialtyCodes.MENTAL_HEALTH ? "mh_note" : "vpc_note"}
          />
        </div>
        <div className={styles.activePatientsContainer}>
          {translate(null, "provider_panel.form.fields.active_panel", "label")}:&nbsp;
          <b>{participant ? participant.providerPanelExtension.activeSize : 0}</b>
        </div>
      </FieldValue>

      <TextField
        autoComplete="off"
        name={fieldTypes.MAX_PANEL}
        placeholder={translate(null, "provider_panel.form.fields.max_panel", "placeholder")}
      />
    </FieldLabel>
  )
});

MaxPanelField.displayName = "MaxPanelField";

export default MaxPanelField;

